import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  BRAND, Icon, Button, Frame,
} from '../../../components/onboarding/primitives';

/**
 * Props contract:
 *   title?      — heading override (default: "تم تفعيل حسابك!")
 *   subtitle?   — body override
 *   ctaLabel?   — button label override
 *   ctaPath?    — navigation target (default: /onboarding/setup)
 *
 * Used both at the end of new-tenant onboarding (default copy → SetupWizard)
 * and at the end of subscription renewal/upgrade (custom copy → settings).
 */
export default function Step9Activated({
  title,
  subtitle,
  ctaLabel,
  ctaPath,
}) {
  const navigate = useNavigate();
  const heading = title || 'تم تفعيل حسابك!';
  const body = subtitle || (
    <>
      أكمل إعداد مختبرك الآن — بياناتك الأساسية محفوظة، وباقي الإعداد
      <br />
      يأخذ دقيقتين فقط.
    </>
  );
  const buttonLabel = ctaLabel || 'ابدأ إعداد المختبر';
  const targetPath = ctaPath || '/onboarding/setup';

  return (
    <Frame maxWidth={600}>
      <div style={{ textAlign: 'center', padding: '60px 0' }}>
        <div
          style={{
            width: 120,
            height: 120,
            borderRadius: 60,
            background: `linear-gradient(135deg, ${BRAND.greenDark}, ${BRAND.greenGlow})`,
            margin: '0 auto 28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 20px 50px rgba(15,110,86,0.3)',
          }}
        >
          <Icon.Check color="#fff" size={56} />
        </div>
        <h1 style={{ fontSize: 34, fontWeight: 800, margin: '0 0 12px', letterSpacing: -0.8 }}>
          {heading}
        </h1>
        <p
          style={{
            fontSize: 16,
            color: BRAND.muted,
            margin: '0 0 32px',
            lineHeight: 1.7,
          }}
        >
          {body}
        </p>
        <Button icon={<Icon.Arrow />} onClick={() => navigate(targetPath)}>
          {buttonLabel}
        </Button>
      </div>
    </Frame>
  );
}
